import React, { ChangeEvent, FunctionComponent } from "react";

import { Caption, GridColumnCount, GridGapSize, GridLayout, GridLayoutItem } from "@multiweb/reactComponents";
import { IAttrValue } from "@multiweb/types/contracts";
import { LOC_CONDITION, LOC_NAME, LOC_ROLE } from "../../../../../locKeys";
import { IParticipant, WorkflowEditorProps } from "../../../../../types";
import { CONST_DEFINITION_PARTICIPANT_CONDITION_AT, CONST_DEFINITION_PARTICIPANT_NAME_AT, CONST_DEFINITION_PARTICIPANT_ROLE_NAME_AT } from "../../../../../workflowParser/constants";
import { Edit, Memo, TextLOVEdit } from "../../../components";

type DefinitionParticipantEditPage = {
    readonly selectedParticipant: IParticipant;
    readonly updateDefParticipant: (participant: IParticipant, propertyName: string, newValue: string) => void;
} & WorkflowEditorProps;

const getRoleNameAttrs = ["Fyzicke_jmeno"];

export const DefinitionParticipantsEditPage: FunctionComponent<DefinitionParticipantEditPage> = ({ hostKey, selectedParticipant, updateDefParticipant }) => {
    const getRoleName = (results: readonly IAttrValue[] | undefined) => {
        if (results)
            updateDefParticipant(selectedParticipant, CONST_DEFINITION_PARTICIPANT_ROLE_NAME_AT, results[0]?.toString());
    };

    const updateDefPartName = (e: ChangeEvent<HTMLInputElement>) => {
        updateDefParticipant({ ...selectedParticipant, name: e.target.value }, CONST_DEFINITION_PARTICIPANT_NAME_AT, e.target.value);
    };

    const updateCondition = (e: ChangeEvent<HTMLTextAreaElement>) => {
        updateDefParticipant(selectedParticipant, CONST_DEFINITION_PARTICIPANT_CONDITION_AT, e.target.value);
    };

    const updateRoleName = (e: ChangeEvent<HTMLInputElement>) => {
        updateDefParticipant(selectedParticipant, CONST_DEFINITION_PARTICIPANT_ROLE_NAME_AT, e.target.value);
    };

    return (
        <GridLayout columns={GridColumnCount.one} gap={GridGapSize.two}>
            <GridLayoutItem>
                <Caption required locKey={LOC_NAME} />
                <Edit required maxLength={128} value={selectedParticipant.properties[CONST_DEFINITION_PARTICIPANT_NAME_AT]} onChange={updateDefPartName} {...{ hostKey }} />
            </GridLayoutItem>
            <GridLayoutItem>
                <Caption locKey={LOC_ROLE} />
                <TextLOVEdit
                    value={selectedParticipant.properties[CONST_DEFINITION_PARTICIPANT_ROLE_NAME_AT]}
                    formName="FRM.CRole.CRole"
                    attributeNames={getRoleNameAttrs}
                    maxLength={255}
                    onChange={updateRoleName}
                    onFormClose={getRoleName}
                    {...{ hostKey }} />
            </GridLayoutItem>
            <GridLayoutItem>
                <Caption locKey={LOC_CONDITION} />
                <Memo value={selectedParticipant.properties[CONST_DEFINITION_PARTICIPANT_CONDITION_AT]} onChange={updateCondition} {...{ hostKey }} />
            </GridLayoutItem>
        </GridLayout>
    );
};
